import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Portfolio data (tu peux aussi l'importer depuis un fichier si tu préfères)
const portfolioData = [
  {
    id: 1,
    image: "/images/lizayTech.jpg",
    title: "Lizay Company",
    overview: "Website Development",
    service: "Web",
  },
  {
    id: 2,
    image: "/images/mobilePort.png",
    title: "Furnish",
    overview: "Mobile Development",
    service: "Mobile",
  },
  {
    id: 3,
    image: "/images/mobileApp.png",
    title: "FitWave",
    overview: "Mobile Development",
    service: "Mobile",
  },
  {
    id: 4,
    image: "/images/cloud.png",
    title: "Data Pam",
    overview: "Cloud Backup",
    service: "Cloud",
  },
  {
    id: 5,
    image: "/images/finance.png",
    title: "Finans Pam",
    overview: "Financial Systems",
    service: "Finance",
  },
  {
    id: 6,
    image: "/images/ecom.png",
    title: "Ti Mache Pam",
    overview: "E-commerce Platforms",
    service: "E-commerce",
  }
];

// Catégories dynamiques
const categories = ["All", ...Array.from(new Set(portfolioData.map(item => item.service)))];

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredData =
    activeCategory === "All"
      ? portfolioData
      : portfolioData.filter(item => item.service === activeCategory);

  const { t } = useTranslation();    

  return (
    <section className="text-black bg-gray-100 dark:bg-gray-950 py-20">
      <div className="container mx-auto px-6"> 
        {/* En-tête */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-blue-600 mb-4">{t('portfolio')}</h1>
          <p className="text-gray-600 dark:text-gray-300 text-base max-w-2xl mx-auto">
          {t('titrePortfolio')}
          </p>
        </div>

        {/* Filtres */}
        <div className="flex justify-center flex-wrap mb-10">
          {categories.map((cat, index) => (
            <button
              key={index}
              onClick={() => setActiveCategory(cat)}
              className={`m-2 px-4 py-2 rounded-full transition ${
                activeCategory === cat
                  ? "bg-indigo-600 text-white"
                  : "bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-white"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grille de projets */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {filteredData.map((item) => (
            <div key={item.id} className="bg-white dark:bg-slate-900 rounded-lg overflow-hidden shadow hover:shadow-lg transition">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="text-xl font-bold text-gray-800 dark:text-white">{item.title}</h3>
                <p className="text-blue-600 font-medium">{item.overview}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
